import { render, staticRenderFns } from "./NextUpEvents.vue?vue&type=template&id=81b7a494&scoped=true"
import script from "./NextUpEvents.vue?vue&type=script&lang=js"
export * from "./NextUpEvents.vue?vue&type=script&lang=js"
import style0 from "./NextUpEvents.vue?vue&type=style&index=0&id=81b7a494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b7a494",
  null
  
)

export default component.exports